const d3 = require("d3");
const { XLocationToHour, hourToXLocation, getTranslation } = require("./../visualHelperFunctions.js")
const { parseSvg } = require("d3-interpolate/src/transform/parse");


class MilestoneVisual {
    constructor(visualiser, projectVisual) {
        this.visualiser = visualiser;
        this.projectVisual = projectVisual;
        this.project = projectVisual.project;

        var milestoneLocations = this.getMilestoneLocations();
        this.createMilestoneElements(milestoneLocations);
    }

    getMilestoneLocations() {
        const params = this.visualiser.params;

        var x1 = params.paddingLeft + this.project.startHour;
        var x2 = this.project.startHour + (this.project.leadTimeHours + this.project.delay) * params.xScaling + params.paddingLeft;
        var y1 = params.paddingTop - params.milestonePadding;
        var y2 = y1 + params.milestoneHeight;

        return [{ "x1": x1, "x2": x2, "y1": y1, "y2": y2, "project": this.project }];
    }

    //Create the elements for the milestones
    createMilestoneElements(milestoneLocations) {
        var params = this.visualiser.params;
        var visualiser = this.visualiser;
        var self = this
        var clickedPos = 0;
        var startPos = 0;
        var timeBetweenSwaps = 500;

        var lastEventy = 0;

        //Store the current positions to get the right ratio
        function dragStart(event, d) {
            const currtransform = parseSvg(d3.select(this).attr('transform'))
            clickedPos = event.x - visualiser.params.paddingLeft;
            startPos = hourToXLocation(self.project.startHour, visualiser) - visualiser.params.paddingLeft;
        }

        //Update the position of the milestone
        function dragging(event, calledFromInterval) {
            var projectYVal = self.projectVisual.getProjectGroupYLocation(false);
            var neighbourYVals = self.projectVisual.getNeighbouringProjectYVals();

            //Calculate the new position
            var newYVal = projectYVal + event.y - self.visualiser.params.paddingTop;

            //Check if we are in the right range
            if (neighbourYVals[0] != null && newYVal < neighbourYVals[0]) {
                self.projectVisual.swapProjects(true);
                return;
            }

            if (neighbourYVals[1] != null && newYVal > neighbourYVals[1]) {
                self.projectVisual.swapProjects(false);
                return;
            }

            var offSetPosition = event.x - clickedPos - visualiser.params.paddingLeft;

            var newPosition = startPos + offSetPosition;
            var newHour = XLocationToHour(newPosition, visualiser);
            if (newHour < 0) {
                newHour = 0;
            }

            self.project.updateStartHour(newHour, false)
            self.projectVisual.updateElements(0)

            // setTimeout(() => {dragging(event, true)}, timeBetweenSwaps)
        }

        //Snap the location to a correct hour
        function dragEnd(event, d) {
            var roundedHour = Math.round(self.project.startHour)
            self.project.updateStartHour(roundedHour, true)
            self.projectVisual.updateElements(0)

            self.visualiser.state.futureLoadGraph.updateData(true);
        }

        this.milestoneGroup = this.projectVisual.parentGroup.append('g').attr("class", "milestoneGroup").attr('transform', `translate(${0}, ${0})`)
        
        if(this.visualiser.simulator.params.allowPortfolioPlanning){
            this.milestoneGroup.call(d3.drag().on('start', dragStart).on('drag', dragging).on('end', dragEnd));
        }

        this.milestoneRects = this.milestoneGroup.selectAll("milestoneRects")
            .data(milestoneLocations)
            .enter()
            .append("rect")
            .attr("x", function (d, i) {
                return hourToXLocation(d.project.startHour, visualiser)
            })
            .attr("width", function (d, i) {
                return hourToXLocation(d.project.startHour + d.project.leadTimeHours + d.project.delay, visualiser) - hourToXLocation(d.project.startHour, visualiser)
            })
            .attr("y", d => d.y1)
            .attr("height", d => d.y2 - d.y1)
            .attr("class", "milestone")
            .attr("rx", (params.milestoneHeight / 4).toString())
            .attr("fill", d => this.calculateMilestoneColor(d.project))
            .attr("opacity", d => this.calculateMilestoneOpacity(d))

       
        if(this.visualiser.simulator.params.allowPortfolioPlanning){
            this.milestoneRects.style('cursor', 'grab');
                }
        //Create a cut in the line to prevent issues with overlapping colors
        this.milestoneCuts = this.milestoneGroup.selectAll("milestoneCuts")
            .data(milestoneLocations)
            .enter()
            .append("rect")
            .attr("opacity", d => this.calculateMilestoneOpacity(d))
            .attr("width", params.milestoneHeight / Math.sqrt(2))
            .attr("height", params.milestoneHeight / Math.sqrt(2))
            .attr("class", "milestonecut")
            .attr("fill", "rgb(240, 240, 240)")
            .attr("transform", function (d, i) {
                return `translate(${hourToXLocation(d.project.startHour + d.project.leadTimeHours, visualiser)}, ${d.y1}) rotate(45)`;
            });

        //Add a rotated rectangle at the end for better indication
        this.milestoneEndRects = this.milestoneGroup.selectAll("milestoneEndRects")
            .data(milestoneLocations)
            .enter()
            .append("rect")
            .attr("opacity", 1)
            .attr("transform", d => `translate(${d.x2}, ${d.y1}) rotate(45)`)
            .attr("width", params.milestoneHeight / Math.sqrt(2))
            .attr("height", params.milestoneHeight / Math.sqrt(2))
            .attr("fill", "transparent")
            .attr("class", "milestoneend")
            .attr("opacity", d => this.calculateMilestoneOpacity(d))
            .attr("fill", d => this.calculateMilestoneColor(d.project))
            .style('stroke-opacity', '1')
            .style('stroke', 'black')
            .style('stroke-alignmnet', "outer")
            .style('stroke-width', '2')
            .attr("transform", function (d, i) {
                return `translate(${hourToXLocation(d.project.startHour + d.project.leadTimeHours, visualiser)}, ${d.y1}) rotate(45)`;
            });

        var tooltipVisual = self.visualiser.tooltipVisual;

        if (this.visualiser.simulator.params.allowPortfolioPlanning) {
            this.milestoneRects.on("mouseover", function (d) { tooltipVisual.showToolTipVisual(d, self.project) })
            .on("mousemove", function (d) { tooltipVisual.moveToolTipVisual(d, self.project) })
            .on("mouseout", function (d) { tooltipVisual.hideToolTipVisual(d, self.project) })
        }
    }

    updateElements(duration) {


        var visualDuration = 200;
        var visualiser = this.visualiser;

        //Remove the drag callbacks for the milestones, and reset its cursor
        if (this.project.simulator.hoursPassed > 0) {
            this.milestoneGroup.attr('pointer-events', 'none')
            this.milestoneRects.attr('pointer-events', 'none')
            this.milestoneGroup.call(d3.drag().on('start', null).on('drag', null).on('end', null));
            this.milestoneRects.style('cursor', 'default')
        }


        //Move all milestones
        this.milestoneRects
            .transition("moveMilestones")
            .ease(d3.easeLinear)
            .duration(duration)
            .attr("fill", d => this.calculateMilestoneColor(d.project))
            .attr("opacity", d => this.calculateMilestoneOpacity(d))
            .attr("x", function (d, i) {
                return hourToXLocation(d.project.startHour, visualiser)
            })
            .attr("width", function (d, i) {
                return hourToXLocation(d.project.startHour + d.project.leadTimeHours + d.project.delay, visualiser) - hourToXLocation(d.project.startHour, visualiser)
            });


        this.milestoneRects
            .transition("colorChange")
            .ease(d3.easeLinear)
            .duration(visualDuration)
            .attr("fill", d => this.calculateMilestoneColor(d.project))
            .attr("opacity", d => this.calculateMilestoneOpacity(d))

        //Move the cuts
        this.milestoneCuts
            .transition("moveMilestoneCuts")
            .ease(d3.easeLinear)
            .duration(duration)
            .attr("transform", function (d, i) {
                var t = getTranslation(d3.select(this).attr("transform"));
                return `translate(${hourToXLocation(d.project.startHour + d.project.leadTimeHours, visualiser)}, ${t[1]}) rotate(45)`;
            });

            this.milestoneCuts
            .transition("colorChange")
            .ease(d3.easeLinear)
            .duration(visualDuration)
            .attr("opacity", d => this.calculateMilestoneOpacity(d))

        //MOve the milestone ends
        this.milestoneEndRects
            .transition("moveMilestoneEnds")
            .ease(d3.easeLinear)
            .duration(duration)
            .attr("fill", d => this.calculateMilestoneColor(d.project))
            .attr("transform", function (d, i) {
                var t = getTranslation(d3.select(this).attr("transform"));
                return `translate(${hourToXLocation(d.project.startHour + d.project.leadTimeHours, visualiser)}, ${t[1]}) rotate(45)`;
            });

            this.milestoneEndRects
            .transition("colorChange")
            .ease(d3.easeLinear)
            .duration(visualDuration)
            .attr("opacity", d => this.calculateMilestoneOpacity(d))
    }


    //Calculate the opacity whether we are finished or not
    calculateMilestoneOpacity(d) {

        if (d.project.leadTimeHours < this.visualiser.simulator.hoursPassed && d.project.isFinished()) {
            return 0;
        }

        if (d.project.isFinished()) {
            return 0.25;
        }

        return 1;
    }

    //The milestone color will indicate the status of the project

    calculateMilestoneColor(currProject) {
        //First calculate the status of the project
        var remainingTime = currProject.getRemainingTime();
        var ratio = currProject.getBufferRatio();

        var blue = "#66BCFF";
        var green = "#6CDA66";
        var yellow = "#FFD266";
        var red = "#FF667F";
        
        var colorMapper = {"red": red, "green": green, "blue": blue, "yellow": yellow};

        return colorMapper[currProject.getProjectStatus()];
    }
}

module.exports = { MilestoneVisual };
